module.exports = __webpack_public_path__ + "img/IndexMan.89f84f46.svg";